export default "__VITE_ASSET__DWKy6QrU__"